import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import useMediaColorByFormat from "@/src/hooks/useMediaColorByFormat";

import Tag from "./Tag";
import { getTranslatedMetadata } from "../../utils/data/Content";

import type { JSX } from "react";

import type {
  MediaFormat,
  MediaFormatWithAdBreak,
} from "../../constants/media";
import type { AppState } from "../../reducers";
import type { KeyWithTranslation } from "../../types";

interface Props {
  format: MediaFormatWithAdBreak;
  metadataFormats?: KeyWithTranslation<MediaFormat>[];
}

export default function FastFormatTag({
  format,
  metadataFormats,
}: Props): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const languageId = useSelector(
    (state: AppState) => state.languages.current.uuid,
  );

  const getMediaColor = useMediaColorByFormat();

  const getFormatLabel = (): string | null => {
    const formatWithTranslation = metadataFormats?.find(
      (mediasFormat) => mediasFormat.key === format,
    );

    if (formatWithTranslation) {
      return (
        getTranslatedMetadata as (
          formatWithTranslation: KeyWithTranslation<MediaFormat>,
          key: string,
          languageId: string,
        ) => string | null
      )(formatWithTranslation, "title", languageId);
    }

    return t(format);
  };

  return <Tag color={getMediaColor(format)}>{getFormatLabel()}</Tag>;
}
